import { AllFormDataType } from '../+state/rollout/rollout-plan-form.store';
import { RolloutPlanRequestDto } from '../infrastructure/backends/rollout-plan.dto';

export function transformRolloutDataToRequestBody(data: AllFormDataType): RolloutPlanRequestDto {
  return {
    firmwarePackageId: data.planDetails.firmwarePackageId,
    targetProductGroupIds: data.productGroups.productGroups.map(pg => pg.productGroupId),
    strategy: data.distributionSettings.strategy
  };
}
